import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const BoldSpan = styled.span`
  font-weight: 600;
`;

export const RoadsideAssistanceWrapper = styled.div``;

export const LabelWrapper = styled.div`
  margin-top: ${spacing.space4};
  margin-bottom: ${spacing.space32};
`;

export const ContentWrapper = styled.div`
  max-width: 90%;
`;
